var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheatreLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 132,
    viewBox: "0 0 187 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.96 10.1597L146.49 3.92969L143.34 10.9197L150.96 10.1597Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.15 68.1101C174.84 68.1101 174.54 67.9901 174.3 67.7601L172.1 65.5601C171.63 65.0901 171.63 64.3301 172.1 63.8701C172.57 63.4001 173.33 63.4001 173.79 63.8701L175.99 66.0701C176.46 66.5401 176.46 67.3001 175.99 67.7601C175.77 68.0001 175.46 68.1101 175.15 68.1101Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9096 14.3397C86.6331 14.3397 87.2196 13.7532 87.2196 13.0297C87.2196 12.3062 86.6331 11.7197 85.9096 11.7197C85.1861 11.7197 84.5996 12.3062 84.5996 13.0297C84.5996 13.7532 85.1861 14.3397 85.9096 14.3397Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5 15.5L85.5 29.5",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.92 94.1601L154.39 85.6201",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4298 57.8014L11.3418 61.3164L14.8568 67.4044L20.9448 63.8894L17.4298 57.8014Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.022 118.331L162.754 117.051L161.473 120.319L164.742 121.599L166.022 118.331Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9898 42.5607L23.7217 41.2803L22.4412 44.5484L25.7094 45.8289L26.9898 42.5607Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9697 97.9805L46.1797 105.61L53.1797 102.48L46.9697 97.9805Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.87 96.0099L156.48 92.9199L155.99 98.2699L160.87 96.0099Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2101 18.3C25.6626 18.3 26.8401 17.1225 26.8401 15.67C26.8401 14.2175 25.6626 13.04 24.2101 13.04C22.7576 13.04 21.5801 14.2175 21.5801 15.67C21.5801 17.1225 22.7576 18.3 24.2101 18.3Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1397 86.4298C26.7859 86.4298 27.3097 85.906 27.3097 85.2598C27.3097 84.6137 26.7859 84.0898 26.1397 84.0898C25.4936 84.0898 24.9697 84.6137 24.9697 85.2598C24.9697 85.906 25.4936 86.4298 26.1397 86.4298Z",
    stroke: "#FFA940",
    strokeWidth: 0.7811,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2998 22.7695L14.5798 32.1495",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.91 38.5204L185.98 30.4004",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6104 94.1901L67.6504 80.3701",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2197 75.0103L67.7997 74.3203",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4309 52.5395C67.6047 52.5395 74.2309 45.9133 74.2309 37.7395C74.2309 29.5656 67.6047 22.9395 59.4309 22.9395C51.257 22.9395 44.6309 29.5656 44.6309 37.7395C44.6309 45.9133 51.257 52.5395 59.4309 52.5395Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9904 52.1498C65.1642 52.1498 71.7904 45.5236 71.7904 37.3498C71.7904 29.176 65.1642 22.5498 56.9904 22.5498C48.8166 22.5498 42.1904 29.176 42.1904 37.3498C42.1904 45.5236 48.8166 52.1498 56.9904 52.1498Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7208 30.7396C66.6408 33.4996 60.9508 43.5696 60.9508 43.5696C60.9508 43.5696 49.8808 41.4296 50.0408 36.5896C50.2308 30.7296 56.3808 33.6596 56.3808 33.6596C56.3808 33.6596 58.1808 27.5396 62.7208 30.7396Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3506 41.3799C47.4206 47.1299 53.7606 50.1099 59.5106 48.0399",
    stroke: "white",
    strokeWidth: 0.7811,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5498 55.8604C38.5498 55.8604 55.8898 76.1904 82.5198 59.1504",
    stroke: "#FFA940",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7299 61.63L82.2599 59.29L79.9199 58.76L81.1399 58L83.4799 58.52L82.9499 60.86L81.7299 61.63Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.41 117.06C17.7116 117.06 22.82 111.952 22.82 105.65C22.82 99.3487 17.7116 94.2402 11.41 94.2402C5.10843 94.2402 0 99.3487 0 105.65C0 111.952 5.10843 117.06 11.41 117.06Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 115.58C18.3014 115.58 23.4098 110.471 23.4098 104.17C23.4098 97.8682 18.3014 92.7598 11.9998 92.7598C5.69827 92.7598 0.589844 97.8682 0.589844 104.17C0.589844 110.471 5.69827 115.58 11.9998 115.58Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99023 106.88C11.3202 109.2 15.8902 108.38 18.2002 105.06",
    stroke: "#FFA940",
    strokeWidth: 0.6257,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43008 96.9502L6.84008 98.8502L9.78008 97.9402L8.72008 100.83L10.4901 103.34L7.42008 103.22L5.57008 105.69L4.74008 102.73L1.83008 101.74L4.38008 100.03L4.43008 96.9502Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1396 96.0299L15.1596 95.4499L16.3896 92.6299L17.8796 95.3299L20.9396 95.6299L18.8396 97.8799L19.4996 100.89L16.7096 99.5799L14.0496 101.13L14.4396 98.0799L12.1396 96.0299Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07 74.46C157.07 74.46 162.82 57.2 161.67 51.45C160.52 45.7 155.81 41.36 155.81 41.36L146.15 47.13L140.09 83.03L144.98 99.2C144.98 99.2 135.62 109.37 121.36 112.61C118.66 113.22 115.78 113.59 112.76 113.59C93.7701 113.59 108.16 87.12 108.16 87.12L108.46 78.33C108.64 73.17 107.37 68.06 104.81 63.57L101.83 58.35L161.82 12.59L165.98 11.46L170.41 16.06V21.24L168.41 22.97C168.42 22.96 170.88 59.5 157.07 74.46Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.167 72.8848C145.008 69.2395 150.266 55.7862 145.911 42.8359C141.557 29.8856 129.238 22.3424 118.397 25.9876C107.557 29.6328 102.299 43.0862 106.653 56.0365C111.008 68.9867 123.326 76.53 134.167 72.8848Z",
    fill: "#FF922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.75 110.611C127.75 110.611 131.22 113.101 127.75 121.971C124.28 130.841 117.99 136.841 118.56 136.841C119.14 136.841 131.61 136.841 131.61 136.841C131.61 136.841 139.8 132.271 141.81 122.931C143.82 113.591 142.97 101.141 142.97 101.141C142.97 101.141 133.53 108.801 127.75 110.611Z",
    fill: "#FF922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.93 137.04L121.37 112.6L104.22 109.75L98.7197 138L109.93 137.04Z",
    fill: "#FF922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.596 70.583C144.437 66.9378 149.695 53.4844 145.341 40.5342C140.986 27.5839 128.668 20.0406 117.827 23.6859C106.986 27.3311 101.728 40.7844 106.083 53.7347C110.437 66.685 122.756 74.2282 133.596 70.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.989 11.4603L166.569 7.43034L167.719 5.13034V2.47034C168.179 2.47034 168.579 2.79034 168.679 3.25034L169.469 6.97034L175.559 0.200344C175.689 0.0603438 175.899 0.0203437 176.069 0.100344C176.519 0.330344 176.679 0.900344 176.399 1.32034C175.209 3.12034 172.449 7.31034 172.899 6.85034C173.329 6.42034 177.369 5.00034 179.329 4.33034C179.899 4.13034 180.519 4.45034 180.699 5.03034C180.809 5.39034 179.789 5.70034 179.799 5.70034C179.829 5.70034 175.199 8.00034 175.199 8.00034L180.469 7.36034C180.749 7.39034 180.959 7.63034 180.959 7.91034C180.959 7.91034 180.959 8.57034 180.329 8.78034L176.349 9.72034L180.029 10.0303C180.949 9.72034 181.099 10.3603 180.949 10.8703C180.949 10.8703 180.369 11.4503 179.799 11.4503L173.459 12.8703L170.429 16.0603L165.989 11.4603Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3496 95.75L62.1896 96.29C61.8396 96.31 61.5696 96.6 61.5696 96.95C61.5696 97.46 61.9296 97.9 62.4296 98L65.5996 98.63L57.3596 106.32C57.1296 106.53 57.0696 106.88 57.2096 107.16C57.3896 107.51 57.8396 107.62 58.1596 107.39L64.1696 102.99L62.4496 109.58C62.2996 110.15 62.7296 110.72 63.3296 110.72C63.6196 110.72 63.8796 110.53 63.9696 110.25L65.6096 104.97L65.9196 106.19C66.0696 106.79 66.6696 107.17 67.2796 107.05L69.0696 106.69L70.3596 106.76C70.9496 106.79 71.4696 106.4 71.6096 105.83L71.9496 104.4L74.8296 101.52L71.3496 95.75Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7596 138.001C98.7596 138.001 98.9596 129.691 97.8096 125.091C96.6596 120.491 93.2096 118.761 93.2096 118.761C93.2096 118.761 94.9396 108.401 89.7596 107.251C84.5796 106.101 74.7996 103.221 74.7996 103.221L71.3496 95.7408L101.84 58.3408L104.59 63.1608C107.3 67.9108 108.64 73.3208 108.45 78.7908L108.31 82.8508L99.2496 89.1408C99.2496 89.1408 110.27 123.041 98.7596 138.001Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.189 33.4105C110.189 33.4105 113.339 60.2005 123.989 58.2305C134.629 56.2505 132.329 29.7905 132.329 29.7905C132.329 29.7905 130.599 25.1905 122.259 26.0505C113.919 26.9105 110.489 30.1305 110.189 33.4105Z",
    fill: "#FF922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.979 30.2806C110.979 30.2806 114.129 57.0706 124.779 55.1006C135.429 53.1306 133.119 26.6606 133.119 26.6606C133.119 26.6606 131.389 22.0606 123.049 22.9206C114.709 23.7806 111.279 27.0006 110.979 30.2806Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.039 35.2609C131.039 35.2609 129.799 33.0109 127.479 32.5209C125.159 32.0409 124.559 32.6309 124.559 32.6309C124.559 32.6309 124.439 29.6909 127.639 29.8809C130.839 30.0909 131.039 35.2609 131.039 35.2609Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.459 46.5605C120.459 46.5605 121.769 48.7705 124.109 49.1805C126.449 49.5905 127.019 48.9705 127.019 48.9705C127.019 48.9705 127.229 51.9105 124.029 51.8105C120.829 51.7105 120.459 46.5605 120.459 46.5605Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.91 36.1507C112.91 36.1507 113.86 33.5607 115.52 32.6607C117.18 31.7707 120.96 33.3207 120.96 33.3207C120.96 33.3207 119.24 28.7907 114.59 31.0507C110.92 32.8407 112.91 36.1507 112.91 36.1507Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.919 37.6508C121.919 37.6508 121.059 45.8608 124.219 45.5408C127.379 45.2208 124.949 37.5508 124.949 37.5508",
    fill: "#FF922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.38 31.2606C121.38 31.2606 121.42 44.7006 124.51 43.8006C127.56 42.9106 124.75 33.7006 123.93 30.5506C123.73 29.7906 123.31 28.6906 122.53 28.7806C121.38 28.9106 121.38 30.0806 121.38 31.2606Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.45 6.59C118.45 6.59 111.55 7.63 109.24 13.39C106.94 19.14 106.94 28.35 104.06 30.07C101.18 31.8 96.5698 26.62 93.6998 30.07C90.8298 33.52 92.5498 40.14 100.03 39.42C107.51 38.7 111.54 28.56 123.04 27.3C134.54 26.04 133.7 35.54 142.42 33.92C149.22 32.66 147.21 19.23 143.76 19.76C140.31 20.29 142.09 22.88 138.75 23.74C135.42 24.6 132.24 13.14 129.78 10.51C127.36 7.93 125.64 5.84 118.45 6.59Z",
    fill: "#E8590C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66 5.03016C117.66 5.03016 110.76 6.07016 108.45 11.8302C106.15 17.5802 106.15 26.7902 103.27 28.5102C100.39 30.2402 95.7798 25.0602 92.9098 28.5102C90.0398 31.9602 91.7598 38.5802 99.2398 37.8602C106.72 37.1402 110.75 27.0002 122.25 25.7402C133.75 24.4802 132.91 33.9802 141.63 32.3602C148.43 31.1002 146.42 17.6702 142.97 18.2002C139.52 18.7302 141.3 21.3202 137.96 22.1802C134.63 23.0402 131.45 11.5802 128.99 8.95016C126.58 6.36016 124.85 4.27016 117.66 5.03016Z",
    fill: "#FF922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.81 10.0998C119.445 10.0998 119.96 9.58493 119.96 8.9498C119.96 8.31468 119.445 7.7998 118.81 7.7998C118.175 7.7998 117.66 8.31468 117.66 8.9498C117.66 9.58493 118.175 10.0998 118.81 10.0998Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.54 15.2805C121.175 15.2805 121.69 14.7656 121.69 14.1305C121.69 13.4953 121.175 12.9805 120.54 12.9805C119.905 12.9805 119.39 13.4953 119.39 14.1305C119.39 14.7656 119.905 15.2805 120.54 15.2805Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.27 22.1797C123.226 22.1797 124 21.4052 124 20.4497C124 19.4943 123.226 18.7197 122.27 18.7197C121.315 18.7197 120.54 19.4943 120.54 20.4497C120.54 21.4052 121.315 22.1797 122.27 22.1797Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6593 34.8402C98.0898 34.8402 99.2493 33.6806 99.2493 32.2502C99.2493 30.8197 98.0898 29.6602 96.6593 29.6602C95.2289 29.6602 94.0693 30.8197 94.0693 32.2502C94.0693 33.6806 95.2289 34.8402 96.6593 34.8402Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.54 26.7797C142.335 26.7797 142.98 25.7499 142.98 24.4797C142.98 23.2094 142.335 22.1797 141.54 22.1797C140.744 22.1797 140.1 23.2094 140.1 24.4797C140.1 25.7499 140.744 26.7797 141.54 26.7797Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3995 46.5605C100.162 46.5605 100.78 45.88 100.78 45.0405C100.78 44.201 100.162 43.5205 99.3995 43.5205C98.6374 43.5205 98.0195 44.201 98.0195 45.0405C98.0195 45.88 98.6374 46.5605 99.3995 46.5605Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.29 38.2705L99.4 45.4505",
    stroke: "#F76707",
    strokeWidth: 0.9065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.82 52.0905C103.82 52.0905 103.27 46.5605 99.3999 46.5605C95.5299 46.5605 97.1899 53.2005 97.1899 53.2005L103.82 52.0905Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.359 58.2908L132.739 53.5908",
    stroke: "#FFC078",
    strokeWidth: 0.9065,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.929 49.6706L133.529 48.1006",
    stroke: "#FFC078",
    strokeWidth: 0.9065,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.75 40.2705H134.31",
    stroke: "#FFC078",
    strokeWidth: 0.9065,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.39 70.04L127.26 58.29",
    stroke: "#FFC078",
    strokeWidth: 0.9065,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.85 66.9104L120.2 59.8604",
    stroke: "#FFC078",
    strokeWidth: 0.9065,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.02 58.2901L115.5 54.3701",
    stroke: "#FFC078",
    strokeWidth: 0.9065,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.88 50.4506L111.58 48.8906",
    stroke: "#FFC078",
    strokeWidth: 0.9065,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.1 39.4805L110.02 41.0505",
    stroke: "#FFC078",
    strokeWidth: 0.9065,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.98 32.1807L143.09 36.6107",
    stroke: "#F76707",
    strokeWidth: 0.9065,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.09 37.7109C143.852 37.7109 144.47 37.0304 144.47 36.1909C144.47 35.3514 143.852 34.6709 143.09 34.6709C142.328 34.6709 141.71 35.3514 141.71 36.1909C141.71 37.0304 142.328 37.7109 143.09 37.7109Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1 45.0405C141.1 45.0405 139.77 38.2705 143.09 37.7105C146.41 37.1605 148.81 43.5205 148.81 43.5205L141.1 45.0405Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.43 82.9702C129.728 82.9702 130.78 81.7435 130.78 80.2302C130.78 78.717 129.728 77.4902 128.43 77.4902C127.132 77.4902 126.08 78.717 126.08 80.2302C126.08 81.7435 127.132 82.9702 128.43 82.9702Z",
    fill: "#FF922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7 82.19C135.997 82.19 137.05 80.9632 137.05 79.45C137.05 77.9367 135.997 76.71 134.7 76.71C133.402 76.71 132.35 77.9367 132.35 79.45C132.35 80.9632 133.402 82.19 134.7 82.19Z",
    fill: "#FF922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.23 85.4605C108.23 85.4605 125.13 90.9105 140.1 83.0205L141.39 87.2905C141.39 87.2905 136.57 93.1005 125.84 92.7305C115.11 92.3605 106.55 90.4605 106.55 90.4605L108.17 87.1005L108.23 85.4605Z",
    fill: "#FFA940"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheatreLeftImage);
export default __webpack_public_path__ + "static/media/theatreLeftImage.6b40cc26de1bdd084a03934313c2a218.svg";
export { ForwardRef as ReactComponent };